import React, { useState, useEffect } from 'react'
import 'antd/lib/select/style/index.css'
import { Card, CardBody, Col, Row, Input } from "reactstrap"
import { Button, Pagination, Modal, Spin, Empty, Table, message } from 'antd'
import { DeleteOutlined, WarningOutlined } from '@ant-design/icons'
import UseDebounce from './helpers/UseDebounce'
import MaterialTable from './table/MaterialTable'
import { getListMaterials, importMaterial } from '../../../services/api/apiSku'
import * as XLSX from 'xlsx'
import Papa from 'papaparse'
import { Link } from 'react-router-dom'
import MaterialNewModal from './MaterialNewModal'

const LIMIT = [
    { name: '20 rows', value: 20 },
    { name: '50 rows', value: 50 },
    { name: '100 rows', value: 100 },
    { name: '200 rows', value: 200 },
]

const MaterialPage = () => {
    const [listMaterials, setListMaterials] = useState([])
    const [name, setName] = useState('')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(20)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [fileName, setFileName] = useState('')
    const [dataFile, setDataFile] = useState([])
    const [fileKeys, setFileKeys] = useState([])
    const [loadingFile, setLoadingFile] = useState(false)
    const [errorFile, setErrorFile] = useState('')

    const nameDebounce = UseDebounce(name, 1000)

    useEffect(() => {
        fetchListMaterial()
    }, [page, limit, nameDebounce])

    const fetchListMaterial = async () => {
        setLoading(true)
        try {
            const payload = {
                page, limit
            }
            if (nameDebounce) payload.name = nameDebounce

            const { data: res } = await getListMaterials(payload)
            const { data, success, message: mess } = res
            if (!success) return message.error(mess)

            setListMaterials(data.data)
            setTotal(data.total)
        } catch (error) {
            setError(error.message)
        } finally {
            setLoading(false)
        }
    }

    const handlePageChange = (page, pageSize) => {
        setLimit(pageSize)
        setPage(pageSize !== limit ? 1 : page)
    }

    const _handleChangeLimit = (e) => {
        setLimit(e.target.value)
        setPage(1)
    }

    const _handleChangeSearch = e => {
        const { value } = e.target
        setName(value)
        setPage(1)
    }

    const onShowModal = () => {
        setIsModalOpen(true)
    }

    const onCancel = () => {
        setLoadingFile(false)
        setFileName('')
        setErrorFile('')
        setDataFile([])
        setIsModalOpen(false)
    }

    const onUpdateImport = async () => {
        try {
            const { data } = await importMaterial({ materials: dataFile })
            const { message: mess, success } = data
            if (!success) return setErrorFile(mess)

            message.success("Import file success")
            onCancel()
            fetchListMaterial()
        } catch (error) {
            setErrorFile(error.message)
        }
    }

    const handleChangeFile = (e) => {
        setErrorFile('')
        const { files } = e.target

        if (!files || !files[0]) {
            return
        }
        if (!files[0].name.includes('.csv')) {
            setLoadingFile(false)
            setFileKeys([])
            setDataFile([])
            setFileName('')
            return setErrorFile('File upload phải là CSV')
        }

        setLoadingFile(true)
        setFileName(files[0].name)

        const reader = new FileReader()
        reader.readAsText(files[0])
        Papa.parse(files[0], {
            complete: (result) => {
                setDataFile(result.data)
            },
            header: true,
            dynamicTyping: false,
        })

        reader.onload = (e) => {
            const data = e.target?.result
            const workbook = XLSX.read(data, { type: 'binary', encoding: "utf-8" })
            const sheetName = workbook.SheetNames
            if (sheetName.indexOf('Sheet1') < 0) {
                setLoadingFile(false)
                setErrorFile('File upload không có sheet Sheet1.')
                return
            }
            const sheet = workbook.Sheets['Sheet1']
            const columnsArray = XLSX.utils.sheet_to_json(sheet, { header: 1 })[0]
            if (!(columnsArray.length === 4 && columnsArray?.indexOf('material') > -1 && columnsArray.indexOf('name') > -1 && columnsArray.indexOf('code') > -1 && columnsArray.indexOf('partner') > -1)) {
                setErrorFile('File không đúng cấu trúc. File đúng chỉ gồm 4 trường: "material", "name", "code", "partner".')
            }

            setLoadingFile(false)
            setFileKeys(columnsArray)
        }
    }

    const onChangeFile = (e) => {
        e.target.value = ''
    }

    const onDeleteFile = () => {
        setLoadingFile(false)
        setFileName('')
        setErrorFile('')
        setFileKeys([])
        setDataFile([])
    }

    let isFileFormat = false
    let previewColumns = []
    let previewDataSource = []

    if (dataFile.length > 0) {
        if (fileKeys.length === 4 && fileKeys.indexOf('material') > -1 && fileKeys.indexOf('name') > -1 && fileKeys.indexOf('code') > -1 && fileKeys.indexOf('partner') > -1) {
            isFileFormat = true
        }

        fileKeys.map(item => {
            const columnItem = {
                title: item,
                dataIndex: item,
                key: item
            }

            previewColumns.push(columnItem)
        })

        dataFile.map((item, index) => {
            const dataSourceItem = {
                key: index + 1,
                ...(item)
            }

            previewDataSource.push(dataSourceItem)
        })
    }

    return (
        <div className='MaterialPage'>
            <div className="BackWrapper mb-2">
                <Link to='/sku-manager'><i className='fa fa-chevron-left mr-1' />Quản lý Sku</Link>
            </div>
            <Card>
                <div className="CardHeader card-header header-elements-inline">
                    <div className="header-elements d-flex justify-content-between align-items-center w-100">
                        <h1 className='card-title'>Nguyên vật liệu</h1>
                        <div className="actions">
                            <MaterialNewModal
                                loading={loading}
                                onReload={fetchListMaterial}
                                setLoading={setLoading}
                            />
                            <Button className="btn btn-primary" onClick={onShowModal}>Import</Button>
                            <Modal
                                width="900px"
                                className="ImportModal"
                                visible={isModalOpen}
                                title={'Import NVL'}
                                onOk={onUpdateImport}
                                onCancel={onCancel}
                                footer={[
                                    <Button key="back" onClick={onCancel}>
                                        <i className="fa fa-times" />
                                        Close
                                    </Button>,

                                    <Button id="doImport" key="submit" type="primary" className={loading ? 'loading' : ''}
                                        disabled={!(fileName && isFileFormat && previewColumns.length > 0 && previewDataSource.length > 0)} loading={loading}
                                        onClick={onUpdateImport}>
                                        <i className="fa fa-upload" />
                                        Import
                                    </Button>,
                                ]}
                            >
                                {
                                    loadingFile &&
                                    <div className="modal-loading">
                                        <Spin spinning={true} tip='Loading...' size='large' />
                                    </div>
                                }

                                {
                                    errorFile &&
                                    <span className="noti-error"><WarningOutlined /> {errorFile}</span>
                                }

                                {
                                    fileName && fileName !== '' && isFileFormat && previewColumns.length > 0 && previewDataSource.length > 0 &&
                                    <Table dataSource={previewDataSource} columns={previewColumns} pagination={{ pageSize: 10 }} scroll={{ y: 340 }} />
                                }

                                {
                                    fileName && fileName !== '' && isFileFormat && previewColumns.length === 0 && previewDataSource.length === 0 &&
                                    <Empty />
                                }

                                <div className="ImportNVL">
                                    <div className="AttachFile">
                                        <input
                                            id={`import_select_file`}
                                            type="file"
                                            accept=".csv"
                                            multiple={false}
                                            onChange={handleChangeFile}
                                            onClick={onChangeFile}
                                        />
                                        <label htmlFor={`import_select_file`} id={`import_select_file`}
                                            className="d-block mb-0 cursor-pointer">
                                            <i className="fa fa-cloud-upload" /> Attach file
                                        </label>
                                    </div>

                                    <div className="ListFileInput">
                                        {
                                            fileName && fileName !== '' &&
                                            <div className="file-item">
                                                <div className="Left">
                                                    <span className="FileName">{fileName}</span>
                                                </div>

                                                <DeleteOutlined onClick={onDeleteFile} />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </Modal>
                        </div>
                    </div>
                </div>
                <CardBody>
                    <div className="MaterialFilters mb-3 p-3">
                        <Row form>
                            <Col lg={4} className="mr-2">
                                <div>Tên</div>
                                <Input
                                    style={{ width: '70%' }}
                                    value={name}
                                    placeholder='Nhập tên ...'
                                    onChange={_handleChangeSearch}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                        <div>{error && <div className="text-danger">{error}</div>}</div>
                        <div className='d-flex align-items-center'>
                            <div className='d-flex align-items-center mr-3'>
                                <div>Hiển thị</div>
                                <Input type='select' value={limit} name='limit' onChange={_handleChangeLimit}
                                    className='ml-1 mr-1 w-auto'>
                                    {
                                        LIMIT.map(item => {
                                            return <option key={item.value} value={item.value}>{item.name}</option>
                                        })
                                    }
                                </Input>
                            </div>
                            <div>
                                Tổng số <strong>{total}</strong> nguyên vật liệu
                            </div>
                        </div>
                    </div>

                    <MaterialTable
                        listMaterials={listMaterials}
                        loading={loading}
                        setLoading={setLoading}
                        error={error}
                        onReload={fetchListMaterial}
                    />

                    <Pagination
                        pageSizeOptions={['20', '50', '100', '200']}
                        onChange={handlePageChange}
                        className='text-right mt-3'
                        pageSize={limit}
                        showSizeChanger
                        current={page}
                        total={total}
                    />

                </CardBody>
            </Card>
        </div>
    )
}

export default MaterialPage